var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "960",
      "persistent": "",
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.mobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', _vm._b({
    staticClass: "d-flex flex-column",
    attrs: {
      "light": "",
      "tile": _vm.$vuetify.breakpoint.mobile
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_vm._v(" 나누리상품권 주문 상세 "), _c('v-spacer'), _vm.canResend ? _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(" 문자 재발송 ")]) : _vm._e(), _vm.canCancel ? _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "error",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 결제취소 ")]) : _vm._e(), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-8",
    staticStyle: {
      "flex": "1 0 auto",
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "d-flex flex-column pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('nshop-order-view-baseinfo', _vm._b({}, 'nshop-order-view-baseinfo', {
    order: _vm.order
  }, false)), _c('nshop-order-view-member', _vm._b({
    staticClass: "mt-8"
  }, 'nshop-order-view-member', {
    order: _vm.order
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('nshop-order-view-payment', _vm._b({}, 'nshop-order-view-payment', {
    order: _vm.order
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2 mt-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('nshop-order-view-pins', _vm._b({}, 'nshop-order-view-pins', {
    order: _vm.order
  }, false))], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }